export function createKoinworksV2Dto(form) {
  const residencyAddressSameAsKTP =
    form.residence_address_same_as_ktp_address === 'true';
  const residencyAddress = residencyAddressSameAsKTP
    ? {}
    : {
        residency_address: {
          province: form.current_residence_address_province,
          city: form.current_residence_address_city,
          district: form.current_residence_address_district,
          sub_district: form.current_residence_address_sub_district,
          zip_code: form.current_residence_address_zip_code,
          detail: form.current_residence_address_detail,
        },
      };
  const familyCard =
    form.family_card_image == null
      ? {}
      : { family_card: form.family_card_image.code };
  const additionalDocuments =
    form.business_type !== 'PT' && form.business_type !== 'CV'
      ? {}
      : {
          pt_or_cv_documents: {
            financial_report: form.financial_report.code,
            deed_of_establishment: form.deed_of_establishment.code,
            deed_of_change: form.deed_of_change.code,
          },
        };
  const koinworksDto = {
    loan: {
      product_code: 'KBZ342483',
      amount: Number(form.loan_amount.split('.').join('')),
      purpose: form.loan_purpose,
      tenure: Number(form.tenure),
    },
    borrower: {
      email: form.email,
      phone_number: `0${form.phone_number}`,
      account_purpose: form.account_purpose,
    },
    business: {
      owner: form.business_owner_name,
      name: form.business_name,
      type: form.business_type,
      established_in: form.business_start_date.format('YYYY-MM-DDTHH:mm:SS'),
      industry: form.business_industry,
      total_employees: form.business_total_employees,
      description: form.business_description,
      npwp_number: form.npwp,
      address: {
        province: form.business_address_province,
        city: form.business_address_city,
        district: form.business_address_district,
        sub_district: form.business_address_sub_district,
        zip_code: form.business_address_zip_code,
        detail: form.business_address_detail,
      },
    },
    personal: {
      nik: form.nik,
      place_of_birth: form.place_of_birth,
      date_of_birth: form.date_of_birth.format('YYYY-MM-DDTHH:mm:SS'),
      gender: form.gender,
      marital_status: form.marital_status,
      religion: form.religion,
      education: form.education_level,
      occupation: form.occupation,
      ktp_address: {
        province: form.ktp_address_province,
        city: form.ktp_address_city,
        district: form.ktp_address_district,
        sub_district: form.ktp_address_sub_district,
        zip_code: form.ktp_address_zip_code,
        detail: form.ktp_address_detail,
      },
      residency_address_same_as_ktp: residencyAddressSameAsKTP,
      ...residencyAddress,
      residence_ownership_status: form.residence_ownership_status,
      residing_duration_in_year: form.living_duration_in_year,
    },
    documents: {
      business: {
        product_image: form.product_image.code,
        store_front_view_image: form.store_front_view_image.code,
        store_left_view_image: form.store_left_view_image.code,
        store_right_view_image: form.store_right_view_image.code,
      },
      personal: {
        ktp: form.ktp_image.code,
        selfie_with_ktp: form.selfie_ktp_image.code,
        ...familyCard,
      },
      bank_account_mutations: {
        month1: form.bank_account_mutation_1.code,
        month2: form.bank_account_mutation_2.code,
        month3: form.bank_account_mutation_3.code,
      },
      ...additionalDocuments,
    },
  };

  return koinworksDto;
}
